// Moje úkoly a levý sloupec na desktopu.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { feedbackTaskCounts } from '../core/feedback-core.js';
import { NAV_MODES, NAV_MODE_KEY, appearance, applyNavModeClasses, navMode, setNavModeValue } from '../core/appearance.js';
import { DASHBOARD_KPI_IDS, DASHBOARD_PERIODS, dashGroup } from '../core/dashboard-config.js';
import { myWorkplaceIdSet, ICONS, auditGroupFilterFieldHtml, canManageContent, canWriteAudits, matchesCurrentCompany, myRole, questionCountForType, realRole, dashboardConfig, esc, fmtDateShort, matchesAuditGroup, openAudits, saveDashboardConfig, scopeBadgeHtml, scopeToggleHtml, filterActionsHtml, sortedAuditTypes, sortedBranches, sortedWorkplaces, state, typesInGroup, workplaceLabel, wpFilterFieldsHtml } from '../core/state.js';
import { buildDashboardCtx, dashGroupMembers, dashKpiTileHtml, dashboardTileApplicable, dashboardTileBody, dashboardTileHeading, workplaceBranchId } from './dashboard.js';
import { isCorrectiveAssignedToMe } from './places.js';
import { setScopeSilent } from '../core/companies.js';
import { allCorrectiveItems, correctiveCodeHtml, isCorrectiveOverdue } from './corrective.js';
import { allVisibleScheduleOccurrences, scheduleListWindow } from './schedule.js';
import { dateTimeInputHtml, render } from '../main-render.js';

// ================= MOJE ÚKOLY (osobní souhrn pro odpovědné osoby/auditory) =================
// Odpovědná osoba = uživatel (pracoviště responsibleUserId, opatření
// responsibleId). Karta se zobrazí jen tomu, koho se něco týká.
function myTasksData(){
  var myWorkplaceIds = myWorkplaceIdSet();

  var myCorrectiveOverdue = [], myCorrectiveOpen = [];
  allCorrectiveItems().forEach(function(item){
    if(item.status==='hotovo' || item.status==='zruseno') return;
    if(!isCorrectiveAssignedToMe(item)) return;
    if(isCorrectiveOverdue(item)) myCorrectiveOverdue.push(item); else myCorrectiveOpen.push(item);
  });

  // Opatření na pracovištích, za která jsem obecná odpovědná osoba — i
  // když zrovna konkrétně nejsou "moje" (jiné jméno u opatření). Počítáme
  // zvlášť ta po termínu a zvlášť ta zatím v termínu, aby pracoviště se
  // samými nedořešenými-ale-ne-po-termínu opatřeními nepůsobilo jako
  // "v pořádku".
  var wpOverdueCounts = {}, wpOpenCounts = {};
  if(Object.keys(myWorkplaceIds).length){
    allCorrectiveItems().forEach(function(item){
      if(!myWorkplaceIds[item.workplaceId]) return;
      if(item.status==='hotovo' || item.status==='zruseno') return;
      if(isCorrectiveOverdue(item)){
        wpOverdueCounts[item.workplaceId] = (wpOverdueCounts[item.workplaceId]||0)+1;
      } else {
        wpOpenCounts[item.workplaceId] = (wpOpenCounts[item.workplaceId]||0)+1;
      }
    });
  }
  var myWorkplacesList = Object.keys(myWorkplaceIds).map(function(wid){
    var w = state.workplaces.get(wid);
    return {id:wid, name: w?workplaceLabel(w):'?', overdue: wpOverdueCounts[wid]||0, open: wpOpenCounts[wid]||0};
  }).sort(function(a,b){ return (b.overdue-a.overdue) || (b.open-a.open) || a.name.localeCompare(b.name,'cs'); });

  var myOpenAudits = openAudits().filter(function(e){ return e[1].auditorId && e[1].auditorId===state.myId; });

  // Neprovedené audity: moje plánované termíny (jsem auditor), které jsou
  // po termínu a nejsou splněné.
  var sw = scheduleListWindow();
  var missedAudits = state.myId ? allVisibleScheduleOccurrences(sw.start, sw.end)
    // i předaný termín: odpovědnost zůstává původnímu auditorovi (rozhodnutí uživatele 2026-10-31)
    .filter(function(o){ return o.overdue && !o.expired && (o.effectiveAuditorId===state.myId || o.auditorId===state.myId); }).length : 0;

  var fb = feedbackTaskCounts();
  var hasAnything = Object.keys(myWorkplaceIds).length>0 || myCorrectiveOverdue.length>0 || myCorrectiveOpen.length>0 || myOpenAudits.length>0 || missedAudits>0 || fb.newForAdmin>0 || fb.resolvedUnseen>0;
  return {hasAnything:hasAnything, overdue:myCorrectiveOverdue, open:myCorrectiveOpen,
    workplaces:myWorkplacesList, openAudits:myOpenAudits, missedAudits:missedAudits, feedback:fb};
}
function myTasksTotalOverdue(d){
  return d.overdue.length + d.workplaces.reduce(function(s,w){ return s+w.overdue; }, 0);
}
function myTasksCardHtml(){
  // Na desktopu jsou Moje úkoly samostatná dlaždice v levém sloupci pod
  // navigací (renderSideTasks), na Přehledu by byly dvakrát.
  if(isDesktopLayout() || appearance.myTasks===false) return '';
  var d = myTasksData();
  if(!d.hasAnything) return '';
  var html = '<div class="card" style="margin-bottom:14px'+(myTasksTotalOverdue(d)>0?';border-color:var(--nok)':'')+'">';
  html += '<div style="font-weight:700;font-size:var(--fs-lg);margin-bottom:8px">Moje úkoly</div>';
  html += myTasksInnerHtml(d);
  html += '</div>';
  return html;
}
function isDesktopLayout(){
  return !!(window.matchMedia && window.matchMedia('(min-width:1024px)').matches);
}
// Desktop: Moje úkoly jako druhá plovoucí dlaždice v levém sloupci, hned
// pod navigací. Pozice se dopočítá z výšky navigace (počet záložek se liší
// podle role).
function renderSideTasks(){
  var el = document.getElementById('sideTasks');
  if(!el) return;
  var d = (isDesktopLayout() && appearance.myTasks!==false && state.myId && state.ready.audits) ? myTasksData() : null;
  var pop = document.getElementById('sideTasksPop');
  if(!d || !d.hasAnything){ el.style.display = 'none'; el.innerHTML = ''; closeSideTasksPop(); return; }
  el.classList.toggle('has-overdue', myTasksTotalOverdue(d)>0);
  // Plný seznam i ikona s počtem; co je vidět, určí CSS podle režimu
  // levého sloupce (úzký = ikona, po najetí v režimu 'hover' = seznam).
  var urgent = myTasksTotalOverdue(d) + d.missedAudits;
  var total = d.overdue.length + d.open.length + d.openAudits.length + d.missedAudits + (d.feedback ? d.feedback.newForAdmin + d.feedback.resolvedUnseen : 0);
  var n = urgent || total;
  el.innerHTML = '<div class="st-full"><div class="side-tasks-title">Moje úkoly</div>' + myTasksInnerHtml(d) + '</div>' +
    '<button type="button" class="side-tasks-mini'+(state.sideTasksPopOpen?' on':'')+'" title="Moje úkoly" aria-label="Moje úkoly" aria-expanded="'+(state.sideTasksPopOpen?'true':'false')+'" onclick="App.toggleSideTasksPop(event)">' +
      ICONS.tasks + (n ? '<span class="badge-dot'+(urgent?'':' neutral')+'">'+n+'</span>' : '') + '</button>';
  el.style.display = '';
  if(pop){
    if(navMode==='narrow' && state.sideTasksPopOpen){ pop.innerHTML = '<div class="side-tasks-title">Moje úkoly</div>' + myTasksInnerHtml(d); pop.style.display = ''; }
    else { state.sideTasksPopOpen = false; pop.style.display = 'none'; pop.innerHTML = ''; }
  }
  positionSideTasks();
}
function closeSideTasksPop(){
  state.sideTasksPopOpen = false;
  var pop = document.getElementById('sideTasksPop');
  if(pop){ pop.style.display = 'none'; pop.innerHTML = ''; }
}
App.toggleSideTasksPop = function(e){
  if(e) e.stopPropagation();
  if(navMode!=='narrow') return; // v režimu 'hover' se seznam ukáže rozšířením sloupce
  state.sideTasksPopOpen = !state.sideTasksPopOpen;
  renderSideTasks();
};
// Klik mimo panel (nebo na odkaz v něm) ho zavře.
document.addEventListener('click', function(e){
  if(!state.sideTasksPopOpen) return;
  var pop = document.getElementById('sideTasksPop');
  if(pop && pop.contains(e.target) && !e.target.closest('button')) return;
  closeSideTasksPop();
  var mini = document.querySelector('.side-tasks-mini');
  if(mini){ mini.classList.remove('on'); mini.setAttribute('aria-expanded','false'); }
});
App.setNavMode = function(mode){
  if(NAV_MODES.indexOf(mode)<0) return;
  setNavModeValue(mode);
  try{ localStorage.setItem(NAV_MODE_KEY, mode); localStorage.removeItem('bozp-nav-collapsed'); }catch(e){}
  applyNavModeClasses();
  closeSideTasksPop();
  if(document.activeElement && document.activeElement.blur) document.activeElement.blur();
  var wrap = document.getElementById('navMode'); if(wrap) wrap.classList.remove('open');
  render();
};
// Volba režimu levého sloupce: ikona vlevo dole, menu po najetí myší
// (nebo kliknutím / klávesnicí).
var NAV_MODE_LABELS = {wide:'Široké', narrow:'Úzké', hover:'Dynamické'};
var NAV_MODE_HINTS = {wide:'Menu je vždy široké s názvy.', narrow:'Menu je vždy úzké, jen ikony.', hover:'Úzké menu se po najetí myší rozšíří.'};
function renderNavModeMenu(){
  var el = document.getElementById('navMode');
  if(!el) return;
  el.innerHTML = '<button type="button" class="nav-mode-btn" aria-haspopup="true" aria-label="Zobrazení menu" onclick="App.toggleNavModeMenu(event)">'+ICONS.sidebar+'</button>' +
    '<div class="nav-mode-menu" role="menu"><div class="nav-mode-title">Menu</div>' +
    NAV_MODES.map(function(m){
      return '<button type="button" role="menuitemradio" aria-checked="'+(navMode===m?'true':'false')+'" title="'+NAV_MODE_HINTS[m]+'" class="'+(navMode===m?'on':'')+'" onclick="App.setNavMode(\''+m+'\')">' +
        '<span class="nav-mode-check">'+(navMode===m?'✓':'')+'</span>'+NAV_MODE_LABELS[m]+'</button>';
    }).join('') + '</div>';
}
App.toggleNavModeMenu = function(e){
  if(e) e.stopPropagation();
  var wrap = document.getElementById('navMode'); if(wrap) wrap.classList.toggle('open');
};
document.addEventListener('click', function(e){
  var wrap = document.getElementById('navMode');
  if(wrap && wrap.classList.contains('open') && !wrap.contains(e.target)) wrap.classList.remove('open');
});
// Režim 'hover': najetí myší na levý sloupec ho rozšíří a obsah se posune
// (html.nav-peek), odjetí (s malou prodlevou kvůli mezerám mezi
// dlaždicemi) ho zase zúží.
var navPeekTimer = null;
function navColumnEls(){ return ['sideBrand','tabbar','sideTasks'].map(function(id){ return document.getElementById(id); }).filter(Boolean); }
function setNavPeek(on){
  clearTimeout(navPeekTimer);
  if(on){
    if(navMode!=='hover' || !isDesktopLayout()) return;
    document.documentElement.classList.add('nav-peek');
  } else {
    navPeekTimer = setTimeout(function(){ document.documentElement.classList.remove('nav-peek'); positionSideTasks(); updateShellInsets(); }, 120);
  }
  positionSideTasks();
  updateShellInsets();
}
navColumnEls().forEach(function(el){
  el.addEventListener('mouseenter', function(){ setNavPeek(true); });
  el.addEventListener('mouseleave', function(e){
    var to = e.relatedTarget;
    if(to && navColumnEls().some(function(c){ return c.contains(to); })) return;
    setNavPeek(false);
  });
});
function positionSideTasks(){
  var el = document.getElementById('sideTasks'), nav = document.getElementById('tabbar');
  if(!el || !nav || el.style.display==='none') return;
  var top = Math.round(nav.getBoundingClientRect().bottom + 12);
  el.style.top = top + 'px';
  // Dole vlevo je ikona volby zobrazení menu (#navMode) — nechat jí místo.
  el.style.maxHeight = Math.max(120, window.innerHeight - top - 68) + 'px';
  var pop = document.getElementById('sideTasksPop');
  if(pop && pop.style.display!=='none'){
    pop.style.top = top + 'px';
    pop.style.maxHeight = Math.max(160, window.innerHeight - top - 12) + 'px';
  }
}
window.addEventListener('resize', function(){
  var el = document.getElementById('sideTasks');
  var wasShown = el && el.style.display!=='none';
  if(isDesktopLayout()!==wasShown) render(); else positionSideTasks();
});
// Seznamy v Moje úkoly ukazují nejvýš MY_TASKS_LIST_LIMIT položek (nejdéle
// po termínu nahoře), zbytek je za odkazem "+ N dalších" na celý přehled.
var MY_TASKS_LIST_LIMIT = 3;
function myTasksMoreLinkHtml(count, onclick){
  return '<button type="button" class="btn btn-sm btn-ghost" style="padding:2px 6px;margin-top:2px" onclick="'+onclick+'">+ '+count+' další'+(count>=5?'ch':'')+' →</button>';
}
// Odsazení obsahu od plovoucích panelů podle jejich skutečné výšky.
// Panely jsou position:fixed → měří se vůči oknu, nezávisle na posunu.
function updateShellInsets(){
  var app = document.getElementById('app'), top = document.querySelector('.topbar'), dock = document.getElementById('tabbar');
  if(!app || !top) return;
  app.style.setProperty('--shell-top', Math.round(top.getBoundingClientRect().bottom) + 'px');
  app.style.setProperty('--topbar-h', Math.round(top.getBoundingClientRect().height) + 'px');
  renderBrandLogos();
  var bottom = 0;
  if(dock && !isDesktopLayout()) bottom = Math.round(window.innerHeight - dock.getBoundingClientRect().top);
  app.style.setProperty('--shell-bottom', bottom + 'px');
}
window.addEventListener('resize', updateShellInsets);
// Logo BOZP-SOFTWARE z jediného zdroje (window.APP_LOGO_SVG v <head>);
// vykreslí se jednou, sloty jsou mimo #content.
function renderBrandLogos(){
  var side = document.getElementById('sideBrand'), foot = document.getElementById('pageBrand');
  // Jedno logo pevné velikosti; zúžené menu ho jen ořízne na značku
  // (šířka --brand-mark-w), krychle se tak nezvětšuje ani neposouvá.
  if(side && !side.firstChild){
    var vb = (String(window.APP_LOGO_SVG||'').match(/viewBox="[\d.\s-]+ ([\d.]+) ([\d.]+)"/) || [0, 420, 110]);
    side.style.setProperty('--brand-mark-w', (50 * window.APP_LOGO_MARK_WIDTH / parseFloat(vb[2])).toFixed(1) + 'px');
    side.innerHTML = '<span class="brand-clip">'+window.appLogoHtml({height:'50px'})+'</span>';
  }
  if(foot && !foot.firstChild) foot.innerHTML = window.appLogoHtml({height:'36px'});
}
function myTasksInnerHtml(d){
  var html = '';
  var any = false;
  if(d.overdue.length){
    any = true;
    var overdueSorted = d.overdue.slice().sort(function(a,b){ return (a.dueDate||'').localeCompare(b.dueDate||''); });
    html += '<div style="margin-bottom:10px"><div class="muted" style="font-size:var(--fs-sm);margin-bottom:4px">Opatření po termínu, za která odpovídám</div>';
    overdueSorted.slice(0, MY_TASKS_LIST_LIMIT).forEach(function(item){
      // Místo dlouhého popisu jen ID opatření (popis v title).
      html += '<button type="button" class="dash-link-tile task-pill" title="'+esc(item.description||'')+'" onclick="App.openCorrectiveDetail(\''+item.key+'\')">' +
        '<span class="task-pill-text">'+(item.code ? correctiveCodeHtml(item.code) : '<span style="font-weight:600">'+esc(item.description||'(bez popisu)')+'</span>') +
        '<span class="task-pill-sub">'+esc(item.workplaceName)+' · termín '+fmtDateShort(item.dueDate)+'</span></span>' +
        '<span class="badge badge-nok">Po termínu</span></button>';
    });
    if(overdueSorted.length > MY_TASKS_LIST_LIMIT) html += myTasksMoreLinkHtml(overdueSorted.length - MY_TASKS_LIST_LIMIT, 'App.openMyOverdueCorrective()');
    html += '</div>';
  }
  if(d.open.length){
    any = true;
    html += '<div class="muted" style="font-size:var(--fs-sm);margin-bottom:10px">+ '+d.open.length+' opatření v řešení (zatím v termínu)</div>';
  }
  // Moje pracoviště: jen ta s opatřeními po termínu; kliknutí otevře
  // Historii s audity tohoto pracoviště, které mají opatření po termínu.
  var overdueWps = d.workplaces.filter(function(w){ return w.overdue>0; });
  if(overdueWps.length){
    any = true;
    html += '<div style="margin-bottom:10px"><div class="muted" style="font-size:var(--fs-sm);margin-bottom:4px">Pracoviště s opatřeními po termínu</div>';
    overdueWps.slice(0, MY_TASKS_LIST_LIMIT).forEach(function(w){
      html += '<button type="button" class="dash-link-tile task-pill" onclick="App.openWorkplaceOverdueAudits(\''+w.id+'\')">' +
        '<span class="task-pill-text">'+esc(w.name)+'</span>' +
        '<span class="badge badge-nok">'+w.overdue+' po termínu</span></button>';
    });
    if(overdueWps.length > MY_TASKS_LIST_LIMIT) html += myTasksMoreLinkHtml(overdueWps.length - MY_TASKS_LIST_LIMIT, 'App.openMyOverdueAudits()');
    html += '</div>';
  }
  if(d.missedAudits>0){
    any = true;
    html += '<button type="button" class="dash-link-tile task-pill" onclick="App.openMyMissedAudits()">' +
      '<span class="task-pill-text">Neprovedené audity</span><span class="badge badge-nok mono">'+d.missedAudits+'</span></button>';
  }
  if(d.openAudits.length){
    any = true;
    html += '<button type="button" class="dash-link-tile task-pill" onclick="App.setView(\'audit\')">' +
      '<span class="task-pill-text">Moje rozpracované audity</span><span class="badge badge-na mono">'+d.openAudits.length+'</span></button>';
  }
  // Podněty: Administrátor nové ke zpracování, autor vyřízené, které ještě neviděl.
  var fb = d.feedback || {};
  if(fb.newForAdmin){
    any = true;
    html += '<button type="button" class="dash-link-tile task-pill" onclick="App.setView(\'feedbackAdmin\')">' +
      '<span class="task-pill-text">Nové podněty</span><span class="badge badge-na mono">'+fb.newForAdmin+'</span></button>';
  }
  if(fb.resolvedUnseen){
    any = true;
    html += '<button type="button" class="dash-link-tile task-pill" onclick="App.setView(\'myFeedback\')">' +
      '<span class="task-pill-text">Vyřízené podněty</span><span class="badge badge-ok mono">'+fb.resolvedUnseen+'</span></button>';
  }
  if(!any){
    html += '<div class="muted" style="font-size:var(--fs-base)">Žádná otevřená opatření ani audity — vše vyřízeno.</div>';
  }
  return html;
}

// Osobní čísla u ikon v dolní navigaci (Audit/Opatření/Plán/Historie) —
// každé vázané na přihlášený účet, místo dosavadních organizačních
// součtů:
//  - Audit: kolik mám sám rozpracovaných auditů.
//  - Opatření: kolik opatření po termínu je přiřazeno na mě jménem.
//  - Plán: kolik naplánovaných termínů, kde jsem auditor, je po termínu.
//  - Historie: kolik PROVEDENÝCH auditů na pracovištích, za která jsem
//    obecná odpovědná osoba, má aspoň jedno nevyřešené opatření po
//    termínu (počítají se audity, ne jednotlivá opatření).
function myNavBadgeCounts(){
  var myId = state.myId;
  var auditCount = myId ? openAudits().filter(function(e){ return e[1].auditorId===myId; }).length : 0;

  var correctiveCount = 0;
  var items = allCorrectiveItems();
  items.forEach(function(item){
    if(item.status==='hotovo' || item.status==='zruseno') return;
    if(!isCorrectiveOverdue(item)) return;
    if(!isCorrectiveAssignedToMe(item)) return;
    correctiveCount++;
  });

  var w = scheduleListWindow();
  var occ = allVisibleScheduleOccurrences(w.start, w.end);
  var scheduleCount = myId ? occ.filter(function(o){ return o.overdue && !o.expired && (o.effectiveAuditorId===myId || o.auditorId===myId); }).length : 0;

  // Odznaky jen u věcí, které jsou moje a po termínu (rozhodnutí uživatele
  // 2026-10-28): Opatření = moje opatření po termínu, Audity = moje
  // neprovedené termíny. Počet rozpracovaných auditů je jen na jejich záložce.
  return {audit:scheduleCount, corrective:correctiveCount, openAudits:auditCount};
}

// Mobil/tablet: logo uprostřed nad nadpisem jako uvítání (rozhodnutí
// uživatele); na Přehledu pak není logo na konci stránky. Desktop skryje CSS.
// Výška roste s šířkou (varianta C): telefon 34 px (390 px) → širší tablet 56 px (1023 px).
function dashBrandHtml(){
  return '<div class="dash-brand" aria-hidden="true">'+window.appLogoHtml({height:'clamp(34px, calc(20.4px + 3.48vw), 56px)'})+'</div>';
}
// ---------- Začínáme (průvodce prvním spuštěním) ----------
// Karta s kroky pro administrátora/správce, dokud firma nemá vše potřebné
// k prvnímu auditu (rozhodnutí uživatele 2026-10-29). Zmizí po splnění
// všech kroků nebo po „Skrýt“ (jen v tomto prohlížeči).
var ONBOARDING_HIDDEN_KEY = 'bozp-onboarding-hidden';
function onboardingSteps(){
  var cid = state.currentCompanyId;
  var hasAudit = false;
  state.audits.forEach(function(a){ if(!hasAudit && !a.deletedAt && matchesCurrentCompany(a)) hasAudit = true; });
  return [
    // Firmy a pracoviště zakládá administrátor v portálu (fáze 2 ekosystému).
    {done: !!(cid && state.companies.has(cid)), label:'Založte firmu', hint:'Název, IČO a logo — v portálu BOZP-SOFTWARE.',
      onclick: realRole()==='administrator' ? "App.openPortalPlaces()" : ''},
    {done: sortedWorkplaces().length>0, label:'Přidejte pracoviště', hint:'Kde se budou audity provádět — v portálu BOZP-SOFTWARE.',
      onclick: realRole()==='administrator' ? "App.openPortalPlaces('"+(cid||'')+"')" : "App.setView('branding')"},
    {done: sortedAuditTypes().some(function(e){ return e[1].auditMode==='findings' || questionCountForType(e[0])>0; }), label:'Připravte druh auditu', hint:'Nejrychleji převzetím hotové šablony.',
      onclick:"App.setView('questions');App.openAddForm('auditTemplate')"},
    {done: hasAudit, label:'Proveďte první audit', hint:'Na pracovišti, s telefonem v ruce.',
      onclick:"App.openAudits('start')"}
  ];
}
function onboardingCardHtml(){
  if(!canManageContent()) return '';
  if(!(state.ready.companies && state.ready.workplaces && state.ready.auditTypes && state.ready.audits && state.ready.questions)) return '';
  try{ if(localStorage.getItem(ONBOARDING_HIDDEN_KEY)) return ''; }catch(e){}
  var steps = onboardingSteps();
  var doneCount = steps.filter(function(st){ return st.done; }).length;
  if(doneCount===steps.length) return '';
  var next = steps.filter(function(st){ return !st.done; })[0];
  var html = '<div class="card onboarding-card" style="margin-bottom:14px">' +
    '<div class="row-between" style="margin-bottom:8px"><div style="font-weight:700;font-size:var(--fs-lg)">Začínáme</div>' +
    '<span class="muted" style="font-size:var(--fs-sm)">'+doneCount+' ze '+steps.length+'</span></div>';
  steps.forEach(function(st, i){
    var isNext = st===next;
    var clickable = !st.done && st.onclick;
    html += '<'+(clickable?'button type="button" onclick="'+st.onclick+'"':'div')+' class="onboarding-step'+(st.done?' done':'')+(isNext?' next':'')+'">' +
      '<span class="onboarding-num">'+(st.done ? '✓' : (i+1))+'</span>' +
      '<span style="min-width:0"><span class="onboarding-label">'+esc(st.label)+'</span>' +
      (st.done ? '' : '<span class="onboarding-hint">'+esc(st.hint)+'</span>')+'</span>' +
      (clickable ? '<span class="onboarding-go">'+ICONS.chev+'</span>' : '') +
      '</'+(clickable?'button':'div')+'>';
  });
  html += '<button type="button" class="link-btn" style="margin-top:6px;font-size:var(--fs-sm)" onclick="App.hideOnboarding()">Skrýt</button></div>';
  return html;
}
App.hideOnboarding = function(){
  try{ localStorage.setItem(ONBOARDING_HIDDEN_KEY, '1'); }catch(e){}
  render();
};
// Ukazatele na obrazovce Dnes (mobil/tablet).
var TODAY_KPI_IDS = ['kpiOpen','kpiOverdue','kpiPlan','kpiScore'];
// Přehled na mobilu/tabletu = „Dnes“: zahájení auditu, Moje úkoly a čtyři
// ukazatele; plné statistiky jsou na samostatné stránce (state.view 'stats').
// Desktop ukazuje na Přehledu rovnou statistiky (rozhodnutí uživatele 2026-10-28).
function renderToday(){
  var html = dashBrandHtml() +
    '<div class="view-head"><h2>Přehled</h2><p>Co vás dnes čeká.</p></div>';
  if(canWriteAudits()){
    html += '<button type="button" class="btn btn-primary btn-block" style="margin-bottom:14px" onclick="App.openAudits(\'start\')">+ Zahájit audit</button>';
  }
  var onboarding = onboardingCardHtml();
  html += onboarding + myTasksCardHtml();
  if(!state.ready.workplaces || !state.ready.audits){
    html += '<div class="empty"><p>Načítání dat…</p></div>';
    document.getElementById('content').innerHTML = html;
    return;
  }
  if(sortedWorkplaces().length===0){
    if(!onboarding) html += '<div class="empty">' + ICONS.empty + '<p>Zatím nemáte žádné pracoviště.</p>' +
      '<p style="margin-top:10px"><button class="btn btn-primary" onclick="App.setView(\'branding\')">Přidat pracoviště</button></p></div>';
    document.getElementById('content').innerHTML = html;
    return;
  }
  var ctx = buildDashboardCtx();
  html += '<div class="today-kpis">' + TODAY_KPI_IDS.map(function(id){ return dashKpiTileHtml(id, ctx); }).join('') + '</div>';
  html += '<button type="button" class="link-btn" style="margin-top:12px" onclick="App.setView(\'stats\')">Statistiky →</button>';
  document.getElementById('content').innerHTML = html;
}
function renderDashboard(){
  if(state.view==='dashboard' && !isDesktopLayout()){ renderToday(); return; }
  var isStats = state.view==='stats' && !isDesktopLayout();
  var html = (isStats ? '<div class="view-head"><button class="btn btn-sm btn-ghost" style="margin-bottom:10px" onclick="App.goBack(\'dashboard\')">← Zpět</button></div>' : dashBrandHtml()) +
    '<div class="view-head" style="display:flex;align-items:flex-start;justify-content:space-between;gap:10px">' +
    '<div><h2>'+(isStats ? 'Statistiky' : 'Přehled')+'</h2><p>Stav pracovišť a výsledky uzavřených auditů.</p></div>' +
    '<button type="button" class="icon-btn" title="Upravit dashboard" aria-label="Upravit dashboard" style="flex-shrink:0;margin-top:2px" onclick="App.setView(\'dashboardSettings\')">'+ICONS.edit+'</button>' +
    '</div>';
  if(!isStats) html += onboardingCardHtml();

  if(!state.ready.workplaces || !state.ready.audits){
    html += '<div class="empty"><p>Načítání dat…</p></div>';
    document.getElementById('content').innerHTML = html;
    return;
  }

  var cfg = dashboardConfig;
  var noWorkplaces = sortedWorkplaces().length===0;
  var f = cfg.filter || {period:'all', branch:'', wp:'', type:'', group:''};

  if(!noWorkplaces){
    var branchesForFilter = sortedBranches();
    var wpsForFilter = f.branch ? sortedWorkplaces().filter(function(e){ return (e[1].branchId||'')===f.branch; }) : sortedWorkplaces();
    var typesForFilter = sortedAuditTypes();
    var dashActiveFilterCount = (f.period!=='all'?1:0) + (f.branch?1:0) + (f.wp?1:0) + (f.type?1:0) + (f.group?1:0);

    html += '<div class="filter-toggle-row">' +
      '<button type="button" class="filter-toggle-btn'+(state.dashboardFiltersOpen?' on':'')+'" onclick="App.toggleDashboardFiltersOpen()">'+ICONS.filter+' Filtry'+scopeBadgeHtml('dashboard')+
      (dashActiveFilterCount>0 ? '<span class="count-badge">'+dashActiveFilterCount+'</span>' : '')+
      '</button>' +
      '</div>';

    if(state.dashboardFiltersOpen){
      html += '<div class="filter-panel">' + scopeToggleHtml('dashboard');
      html += '<div class="filter-grid" style="margin-bottom:0">' +
        '<div class="field"><label>Období</label>' +
        '<select class="filter-select" id="dashPeriodSelect">' +
        DASHBOARD_PERIODS.map(function(o){ return '<option value="'+o.id+'" '+(f.period===o.id?'selected':'')+'>'+esc(o.label)+'</option>'; }).join('') +
        '</select></div>' +
        (f.period==='custom' ?
          '<div class="field"><label>Od</label><div class="date-wrap">'+dateTimeInputHtml({id:'dashDateFrom', value:f.from||''})+'</div></div>' +
          '<div class="field"><label>Do</label><div class="date-wrap">'+dateTimeInputHtml({id:'dashDateTo', value:f.to||''})+'</div></div>' : '') +
        (branchesForFilter.length>0 ?
          '<div class="field"><label>Provozovna</label>' +
          '<select class="filter-select" id="dashBranchSelect"><option value="">Všechny provozovny</option>' +
          branchesForFilter.map(function(e){ return '<option value="'+e[0]+'" '+(f.branch===e[0]?'selected':'')+'>'+esc(e[1].name)+'</option>'; }).join('') +
          '</select></div>' : '') +
        wpFilterFieldsHtml('dashWpSelect', f.wp||'', wpsForFilter, 'App.setDashboardFilterWp(%s)') +
        auditGroupFilterFieldHtml('dashGroupSelect', f.group||'') +
        '<div class="field"><label>Druh auditu</label>' +
        '<select class="filter-select" id="dashTypeSelect" '+(typesForFilter.length===0?'disabled':'')+'><option value="">Všechny druhy</option>' +
        typesInGroup(typesForFilter, f.group||'').map(function(e){ return '<option value="'+e[0]+'" '+(f.type===e[0]?'selected':'')+'>'+esc(e[1].name)+'</option>'; }).join('') +
        '</select></div>' +
        '</div>';
      html += filterActionsHtml('clearDashboardFilter', 'dashboard', (f.period||'all')==='all' && !f.branch && !f.wp && !f.type && !f.group);
      html += '</div>';
    }
  }

  if(noWorkplaces){
    html += '<div class="empty">' + ICONS.empty +
      '<p>Zatím nemáte žádné pracoviště.</p>' +
      '<p style="margin-top:10px"><button class="btn btn-primary" onclick="App.setView(\'branding\')">Přidat pracoviště</button></p></div>';
    document.getElementById('content').innerHTML = html;
    wireDashboardFilterInputs();
    return;
  }

  var ctx = buildDashboardCtx();

  // Vysvětlení šipek u ukazatelů — jednou nad dlaždicemi, ne v každé.
  if(cfg.order.some(function(id){
    if(cfg.visible[id]===false || !dashboardTileApplicable(id, ctx)) return false;
    return DASHBOARD_KPI_IDS.indexOf(id)>=0 || (dashGroup(id) && dashGroupMembers(id, ctx).length>0);
  })){
    html += '<div class="kpi-note dash-cmp-note">'+(ctx.win ? 'Šipky u ukazatelů: změna proti předchozímu stejně dlouhému období.' : 'Šipky u ukazatelů se ukážou po výběru období ve Filtrech. Křivky: posledních 12 měsíců.')+'</div>';
  }
  html += '<div class="dashboard-grid">';
  cfg.order.forEach(function(id){
    if(cfg.visible[id]===false) return;
    if(!dashboardTileApplicable(id, ctx)) return;
    if(dashGroup(id) && !dashGroupMembers(id, ctx).length) return;
    var heading = dashboardTileHeading(id);
    html += '<div class="dash-tile size-'+(cfg.sizes[id]||'m')+(DASHBOARD_KPI_IDS.indexOf(id)>=0?' kind-kpi':'')+'">' +
      (heading ? '<h3>'+esc(heading)+'</h3>' : '') +
      dashboardTileBody(id, ctx) +
      '</div>';
  });
  html += '</div>';

  document.getElementById('content').innerHTML = html;
  wireDashboardFilterInputs();
}
function wireDashboardFilterInputs(){
  // Vlastní období: pole data bez onChange, uložení po výběru (stejně jako wireDateFilter).
  ['dashDateFrom','dashDateTo'].forEach(function(id){
    var el = document.getElementById(id);
    if(!el) return;
    var key = id==='dashDateFrom' ? 'from' : 'to';
    var fine = !!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);
    function apply(){ if((dashboardConfig.filter[key]||'')===el.value) return; dashboardConfig.filter[key] = el.value; saveDashboardConfig(dashboardConfig); render(); }
    el.addEventListener('change', function(){ if(fine) apply(); });
    el.addEventListener('blur', apply);
  });
  var periodEl = document.getElementById('dashPeriodSelect');
  if(periodEl) periodEl.addEventListener('change', function(){ App.setDashboardFilterPeriod(periodEl.value); });
  var branchEl = document.getElementById('dashBranchSelect');
  if(branchEl) branchEl.addEventListener('change', function(){ App.setDashboardFilterBranch(branchEl.value); });
  var wpEl = document.getElementById('dashWpSelect');
  if(wpEl) wpEl.addEventListener('change', function(){ App.setDashboardFilterWp(wpEl.value); });
  var typeEl = document.getElementById('dashTypeSelect');
  if(typeEl) typeEl.addEventListener('change', function(){ App.setDashboardFilterType(typeEl.value); });
  var groupEl = document.getElementById('dashGroupSelect');
  if(groupEl) groupEl.addEventListener('change', function(){ App.setDashboardFilterGroup(groupEl.value); });
}
App.setDashboardFilterPeriod = function(v){ dashboardConfig.filter.period = v; saveDashboardConfig(dashboardConfig); render(); };
App.setDashboardFilterBranch = function(v){
  dashboardConfig.filter.branch = v;
  if(v && dashboardConfig.filter.wp && workplaceBranchId(dashboardConfig.filter.wp)!==v){
    dashboardConfig.filter.wp = '';
  }
  saveDashboardConfig(dashboardConfig);
  render();
};
App.setDashboardFilterWp = function(v){ dashboardConfig.filter.wp = v; saveDashboardConfig(dashboardConfig); render(); };
App.setDashboardFilterType = function(v){ dashboardConfig.filter.type = v; saveDashboardConfig(dashboardConfig); render(); };
App.setDashboardFilterGroup = function(v){
  dashboardConfig.filter.group = v;
  if(v && dashboardConfig.filter.type && !matchesAuditGroup(dashboardConfig.filter.type, v)) dashboardConfig.filter.type = '';
  saveDashboardConfig(dashboardConfig);
  render();
};
// toDefault: výchozí nastavení (Moje), jinak vše zrušit (Vše); období vždy „Vše“.
App.clearDashboardFilter = function(toDefault){
  setScopeSilent('dashboard', toDefault ? 'mine' : 'all');
  dashboardConfig.filter = {period:'all', branch:'', wp:'', type:'', group:''};
  saveDashboardConfig(dashboardConfig);
  render();
};
App.toggleDashboardFiltersOpen = function(){ state.dashboardFiltersOpen = !state.dashboardFiltersOpen; render(); };
App.goHistoryWp = function(wpId){
  state.view = 'history';
  state.historyFilterWp = wpId;
  state.historyFilterType = ''; state.historyFilterGroup = '';
  state.historyDetailId = null;
  render();
};
// Datum ve filtru (překreslí seznam). Na dotykových zařízeních se filtr
// použije až po zavření výběru data (blur) — iOS při otevření vloží dnešní
// datum a pošle change; překreslení by výběr hned zavřelo a nešlo by
// vybrat ani vymazat. S myší se použije hned při change.
function wireDateFilter(el, stateKey){
  if(!el) return;
  var fine = !!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches);
  function apply(){ if((state[stateKey]||'')===el.value) return; state[stateKey] = el.value; render(); }
  el.addEventListener('change', function(){ if(fine) apply(); });
  el.addEventListener('blur', apply);
}
App.goHistoryType = function(typeId){
  state.view = 'history';
  state.historyFilterType = typeId; state.historyFilterGroup = '';
  state.historyFilterWp = '';
  state.historyDetailId = null;
  render();
};

// Přehled: klepnutí na měsíc ve Vývoji kvality / na oblast.
App.dashPickTrend = function(i){ state.dashTrendPick = i; render(); };
App.dashToggleArea = function(key){ state.dashAreaOpen = state.dashAreaOpen===key ? null : key; render(); };
// Z dlaždic opatření do seznamu Opatření s odpovídajícím filtrem (filtry
// pracoviště a druhu převezme z Přehledu, panel filtrů zůstane zabalený).
App.dashOpenCorrective = function(kind, responsible){
  var f = dashboardConfig.filter || {};
  state.correctiveFilterWp = f.wp || '';
  state.correctiveFilterType = f.type || ''; state.correctiveFilterGroup = f.group || '';
  state.correctiveFilterStatus = (kind==='hotovo' || kind==='zruseno') ? kind : 'v_reseni';
  state.correctiveOverdueOnly = kind==='overdue';
  state.correctiveFilterResponsible = responsible!=null ? responsible : '';
  state.correctiveFilterAuditor = '';
  state.correctiveDateFrom = '';
  state.correctiveDateTo = '';
  state.correctiveSearch = '';
  state.correctiveAuditFilter = '';
  state.correctiveDetailId = null;
  state.correctiveFiltersOpen = false;
  state.correctivePage = 1;
  App.setView('corrective');
};
App.dashOpenMissedPlan = function(){
  var f = dashboardConfig.filter || {};
  state.scheduleFilterWp = f.wp || '';
  state.scheduleFilterType = f.type || ''; state.scheduleFilterGroup = f.group || '';
  state.scheduleFilterStatus = 'po_terminu';
  state.scheduleSearch = '';
  state.scheduleFiltersOpen = false;
  state.schedulePage = 1;
  App.setView('schedule');
};

export {
  isDesktopLayout,
  myNavBadgeCounts,
  renderDashboard,
  renderNavModeMenu,
  renderSideTasks,
  updateShellInsets,
  wireDateFilter
};
